// Config partagée client + admin.
// SÉCHERESSE : navigation suspendue sur le Doubs — formules bateau bloquées,
// départs calèche adaptés (10h00 / 14h30, 1h30 avec visite du belvédère).
// Sécheresse levée le 04/11/2026 (SECHERESSE = false). La repasser à true si la navigation est de nouveau suspendue.
var SECHERESSE = false;
var DEPARTS = ["10:00", "13:45", "15:15"];
var DEPARTS_ACTIFS = SECHERESSE ? ["10:00", "14:30"] : DEPARTS;

// ── JOURS D'OUVERTURE ─────────────────────────────────────────────
// SOURCE UNIQUE cote client de la regle "ferme lundi, mardi, mercredi".
// Miroir de surabaya-backend/services/horaires.js : les deux fichiers
// doivent rester d'accord. Avant, la regle etait recopiee dans
// getSaison() et getRestoSaison() avec un perimetre different de celui
// du serveur, qui ne fermait que le restaurant.
var MOIS_ETE = [6, 7, 8];          // juin, juillet, aout : ouvert 7j/7
var JOURS_FERMES = [1, 2, 3];      // 0 = dimanche ... 1 = lundi, 2 = mardi, 3 = mercredi
var EXCEPTIONS_OUVERT = ['2026-04-06'];


// ── PÂQUES ────────────────────────────────────────────────────────
// Les calèches reprennent le week-end de Pâques (du samedi) et roulent
// jusqu'au 31 octobre. Le lundi de Pâques est ouvert (comme le 06/04/2026).
// Calcul de la date de Pâques (méthode de Meeus/Jones/Butcher).
function paques(an) {
  var a = an % 19, b = Math.floor(an / 100), c = an % 100;
  var d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25);
  var g = Math.floor((b - f + 1) / 3), h = (19 * a + b - d - g + 15) % 30;
  var i = Math.floor(c / 4), k = c % 4, l = (32 + 2 * e + 2 * i - h - k) % 7;
  var m = Math.floor((a + 11 * h + 22 * l) / 451);
  var mois = Math.floor((h + l - 7 * m + 114) / 31);
  var jour = ((h + l - 7 * m + 114) % 31) + 1;
  return new Date(an, mois - 1, jour, 12, 0, 0);
}
function decaler(date, n) { var x = new Date(date.getTime()); x.setDate(x.getDate() + n); return x; }
function isoDate(date) {
  var p = function (n) { return (n < 10 ? '0' : '') + n; };
  return date.getFullYear() + '-' + p(date.getMonth() + 1) + '-' + p(date.getDate());
}
// Premier jour de la saison calèche : le samedi du week-end de Pâques.
function debutSaisonCaleches(an) { return decaler(paques(an), -1); }

function estJourFerme(dateStr) {
  var iso = String(dateStr || '').slice(0, 10);
  if (!/^\d{4}-\d{2}-\d{2}$/.test(iso)) return false;
  if (EXCEPTIONS_OUVERT.indexOf(iso) !== -1) return false;
  var an = Number(iso.slice(0, 4));
  if (iso === isoDate(decaler(paques(an), 1))) return false;   // lundi de Pâques ouvert
  // Midi local, pas minuit : "2026-09-07" parse tel quel donne minuit UTC,
  // et un visiteur dans un fuseau negatif verrait dimanche au lieu de lundi.
  var d = new Date(iso + 'T12:00:00');
  if (isNaN(d.getTime())) return false;
  if (MOIS_ETE.indexOf(d.getMonth() + 1) !== -1) return false;
  return JOURS_FERMES.indexOf(d.getDay()) !== -1;
}

// Sommes-nous actuellement en horaires d'hiver ? (pilote le bandeau)
function estPeriodeHiver() {
  return MOIS_ETE.indexOf(new Date().getMonth() + 1) === -1;
}

module.exports = {
  SECHERESSE: SECHERESSE, DEPARTS: DEPARTS, DEPARTS_ACTIFS: DEPARTS_ACTIFS,
  MOIS_ETE: MOIS_ETE, JOURS_FERMES: JOURS_FERMES, EXCEPTIONS_OUVERT: EXCEPTIONS_OUVERT,
  estJourFerme: estJourFerme, paques: paques, debutSaisonCaleches: debutSaisonCaleches, estPeriodeHiver: estPeriodeHiver
};
